"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var core_2 = require("@ngx-translate/core");
var dealer_service_1 = require("../../../services/dealer.service");
var storage_service_1 = require("../../../modules/storage/storage.service");
var rxjs_1 = require("rxjs");
var kendo_data_query_1 = require("@progress/kendo-data-query");
var alert_script_types_1 = require("../../../constants/alert-script-types");
var modal_1 = require("ngx-bootstrap/modal");
var admin_custom_scripts_edit_modal_component_1 = require("./admin-custom-scripts-edit-modal.component");
var AdminCustomScriptsComponent = /** @class */ (function () {
    function AdminCustomScriptsComponent(tService, dealerService, storageService, modalService, customScriptService) {
        this.tService = tService;
        this.dealerService = dealerService;
        this.storageService = storageService;
        this.modalService = modalService;
        this.customScriptService = customScriptService;
        this.scriptTypes = [];
        this.languages = [];
        this.dealers = [];
        this.customScripts = [];
        this.pageSize = 20;
        this.skip = 0;
        this.sort = [{
                field: 'scriptTypeLabel',
                dir: 'asc'
            }];
        this.subscriptionAggregator = new rxjs_1.Subscription();
        this.scriptTypeLabelKeys = {
            alert: 'alertScriptLabel',
            alertCrossMakeUsed: 'alertCrossMakeUsedScriptLabel',
            contractEnd: 'contractEndScriptLabel',
            leaseEnd: 'leaseEndScriptLabel',
            mileage: 'mileageScriptLabel',
            inMarket: 'inMarketScriptLabel',
            inMarketEngaged: 'inMarketEngagedScriptLabel',
            warranty: 'warrantyScriptLabel',
            phone: 'phoneScriptLabel',
            conquest: 'conquestScriptLabel',
            cash: 'cashScriptLabel',
            appointment: 'appointmentScriptLabel',
            service: 'serviceScriptLabel',
            privateOffer: 'privateOfferScriptLabel',
            privateOfferWithPreApproval: 'privateOfferWithPreApprovalScriptLabel'
        };
    }
    AdminCustomScriptsComponent.prototype.ngOnInit = function () {
        this.dealers = this.dealerService.getSelectedDealers();
        var dealerId = this.storageService.getItem('selectedDealerId');
        this.selectedDealerId = dealerId > 0 ? dealerId : this.dealers[0].id;
        this.scriptTypes = this.buildScriptTypeOptions();
        this.selectedScriptTypeId = this.scriptTypes.length ? this.scriptTypes[0].id : null;
        this.selectedLanguage = this.languages.length ? this.languages[0].value : null;
        this.loadScripts();
    };
    AdminCustomScriptsComponent.prototype.ngOnDestroy = function () {
        this.subscriptionAggregator.unsubscribe();
        if (this.modalHiddenSubscription) {
            this.modalHiddenSubscription.unsubscribe();
            this.modalHiddenSubscription = null;
        }
    };
    AdminCustomScriptsComponent.prototype.onDealerSelect = function () {
        this.storageService.setItem('selectedDealerId', this.selectedDealerId);
        this.loadScripts();
    };
    AdminCustomScriptsComponent.prototype.onFilterChange = function () {
        this.skip = 0;
        this.refreshGridView();
    };
    AdminCustomScriptsComponent.prototype.pageChange = function (_a) {
        var skip = _a.skip, take = _a.take;
        this.skip = skip;
        this.pageSize = take;
        this.refreshGridView();
    };
    AdminCustomScriptsComponent.prototype.sortChange = function (sort) {
        if (sort[0].field === this.sort[0].field) {
            sort[0].dir = (this.sort[0].dir === 'asc') ? 'desc' : 'asc';
        }
        this.sort = sort;
        this.refreshGridView();
    };
    AdminCustomScriptsComponent.prototype.newScript = function () {
        this.openEditModal(0);
    };
    AdminCustomScriptsComponent.prototype.editScriptItem = function (script) {
        this.openEditModal(script.id);
    };
    AdminCustomScriptsComponent.prototype.loadScripts = function () {
        var _this = this;
        this.busy = rxjs_1.from(this.customScriptService.getCustomScriptsByDealerId(this.selectedDealerId))
            .subscribe(function (scripts) {
            var rawScripts = scripts || [];
            _this.languages = _this.buildLanguageOptions(rawScripts);
            var selectedMatch = _this.languages.find(function (language) { return language.value === _this.selectedLanguage; });
            if (!selectedMatch) {
                _this.selectedLanguage = _this.languages.length ? _this.languages[0].value : null;
            }
            _this.customScripts = rawScripts.map(function (script) { return _this.decorateScript(script); });
            _this.customScripts = kendo_data_query_1.orderBy(_this.customScripts, _this.sort);
            _this.refreshGridView();
        });
        this.subscriptionAggregator.add(this.busy);
    };
    AdminCustomScriptsComponent.prototype.refreshGridView = function () {
        this.customScripts = kendo_data_query_1.orderBy(this.customScripts, this.sort);
        var filteredScripts = this.getFilteredScripts();
        this.gridView = {
            data: filteredScripts.slice(this.skip, this.skip + this.pageSize),
            total: filteredScripts.length
        };
    };
    AdminCustomScriptsComponent.prototype.decorateScript = function (script) {
        return Object.assign({}, script, {
            scriptTypeLabel: this.getScriptTypeLabel(script.scriptTypeID),
            languageLabel: this.getLanguageLabel(script.culture)
        });
    };
    AdminCustomScriptsComponent.prototype.getScriptTypeLabel = function (scriptTypeId) {
        var match = this.scriptTypes.find(function (type) { return type.id === scriptTypeId; });
        return match ? this.tService.instant(match.labelKey) : '';
    };
    AdminCustomScriptsComponent.prototype.getLanguageLabel = function (culture) {
        var match = this.languages.find(function (language) { return language.value === culture; });
        return match ? this.tService.instant(match.labelKey) : culture;
    };
    AdminCustomScriptsComponent.prototype.buildLanguageOptions = function (scripts) {
        var knownLabels = {
            'en-US': 'adminCustomScripts_language_english',
            'fr-CA': 'adminCustomScripts_language_frenchCanadian',
            'es-US': 'adminCustomScripts_language_spanish'
        };
        var seen = new Set();
        var ordered = [];
        scripts.forEach(function (script) {
            var culture = script.culture;
            if (!culture || seen.has(culture)) {
                return;
            }
            seen.add(culture);
            ordered.push({
                value: culture,
                labelKey: knownLabels[culture] || culture
            });
        });
        var byValue = ordered.reduce(function (acc, option) {
            acc[option.value] = option;
            return acc;
        }, {});
        if (byValue['en-US'] && byValue['es-US']) {
            return [byValue['en-US'], byValue['es-US']];
        }
        if (byValue['en-US'] && byValue['fr-CA']) {
            return [byValue['en-US'], byValue['fr-CA']];
        }
        if (byValue['en-CA'] && byValue['fr-CA']) {
            return [byValue['en-CA'], byValue['fr-CA']];
        }
        return ordered.slice(0, 2);
    };
    AdminCustomScriptsComponent.prototype.getFilteredScripts = function () {
        var _this = this;
        return this.customScripts.filter(function (script) {
            var matchesLanguage = _this.selectedLanguage
                ? (script.culture || '').toLowerCase() === _this.selectedLanguage.toLowerCase()
                : true;
            return matchesLanguage;
        });
    };
    AdminCustomScriptsComponent.prototype.buildScriptTypeOptions = function () {
        var _this = this;
        return Object.keys(alert_script_types_1.alertScriptTypes).map(function (key) { return ({
            id: alert_script_types_1.alertScriptTypes[key],
            labelKey: _this.scriptTypeLabelKeys[key] || key
        }); });
    };
    AdminCustomScriptsComponent.prototype.openEditModal = function (id) {
        var _this = this;
        var initialState = {
            id: id || 0,
            dealerId: this.selectedDealerId,
            scriptTypeId: this.selectedScriptTypeId,
            culture: this.selectedLanguage
        };
        this.bsModalRef = this.modalService.show(admin_custom_scripts_edit_modal_component_1.AdminCustomScriptsEditModalComponent, { initialState: initialState, class: 'modal-lg' });
        if (this.modalHiddenSubscription) {
            this.modalHiddenSubscription.unsubscribe();
        }
        this.modalHiddenSubscription = this.modalService.onHidden.subscribe(function () {
            _this.loadScripts();
            if (_this.modalHiddenSubscription) {
                _this.modalHiddenSubscription.unsubscribe();
                _this.modalHiddenSubscription = null;
            }
            _this.bsModalRef = null;
        });
    };
    return AdminCustomScriptsComponent;
}());
exports.AdminCustomScriptsComponent = AdminCustomScriptsComponent;
